@if(currentSection === 'packageMetadata'){
<div>
  <div class="py-200-rem px-250-rem grid">
    <div class="flex flex-col space-y-050-rem">
      <h1 class="text-headline-md-weight-medium text-action-fg-secondary">Package metadata</h1>
      <p class="text-container-fg-muted text-label-md-weight-regular">
        Provide provide a name and classification for this firmware package.
      </p>
    </div>

    <div
      class="py-150-rem px-150-rem mt-150-rem rounded-050 bg-container-bg-default border border-container-border-default w-4xl max-w-4xl gap-6 flex flex-col">
      <form class="px-025-rem space-y-075-em" [formGroup]="packageMetadataForm">
        <div class="flex flex-col">
          <h3 class="text-label-lg-weight-medium text-container-fg-default">Package name</h3>

          <input
            class="border rounded-050 max-w-md p-3 border-container-fg-muted mt-2"
            matInput
            formControlName="packageName"
            placeholder="Package name"
            maxlength="100"
            [class.border-error]="
    packageMetadataForm.get('packageName')?.invalid && error
  " />

          @if (packageMetadataForm.get('packageName')?.invalid && error) {
          <div class="flex gap-2 items-center mt-1">
            <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error"></i>
            <mat-error class="text-label-sm-weight-regular text-[12px] text-feedback-fg-error"
              >Enter a package name (max 100 characters)</mat-error
            >
          </div>
          } @else {
          <mat-hint class="text-label-sm-weight-regular text-container-fg-muted text-[12px]"
            >Please set a package name for this firmware package.</mat-hint
          >
          }
        </div>

        <div>
          <h3 class="text-label-lg-weight-medium text-container-fg-default">Update class</h3>

          <mat-radio-group
            aria-label="update classification"
            class="grid pt-025-rem radio-wrapper"
            [class.radio-danger]="packageMetadataForm.get('classification')?.invalid && error"
            formControlName="classification">
            <mat-radio-button value="Critical update">Critical update</mat-radio-button>
            <mat-radio-button value="Major update">Major update</mat-radio-button>
            <mat-radio-button value="Minor update">Minor update</mat-radio-button>
          </mat-radio-group>

          @if(packageMetadataForm.get('classification')?.invalid && error) {
          <div
            class="flex items-center text-label-sm-weight-regular gap-025-em text-feedback-fg-error mt-025-em">
            <i class="icon_marina_ui_CrossContainedOutlined text-feedback-fg-error text-[1rem]"></i>
            <span>Select an update class</span>
          </div>
          }
        </div>
      </form>
    </div>
  </div>
</div>
}
